import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PDF_API_URL } from 'app/config';

@Injectable()
export class PdfMakeLoaderService {

  constructor( private http: HttpClient ) {}

  public generatePdf(content) {
    return this.http.post(
      PDF_API_URL,
      { docDefinition: content },
      {
        headers: { Accept: 'application/pdf' },
        responseType: 'blob',
      },
    ).toPromise();
  }

  public downloadFile(file, filename) {
    const { URL } = window;
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.download = `${link.download}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
